module.exports = __webpack_public_path__ + "img/parc3.fcfed511.png";